import AwardsSection from "@components/new-ui/AwardsSection";
import ClientLogos, { LogoObject } from "@components/new-ui/ClientLogos";
import { container_classname } from "@components/new-ui/constants";
import CTASection from "@components/new-ui/CTASection";
import FeatureInfoCard, { FeatureInfo } from "@components/new-ui/IndustriesSection/FeatureInfoCard";
import Herosection from "@components/new-ui/IndustriesSection/Herosection";
import ProductSection from "@components/new-ui/IndustriesSection/ProductSection";
import StatsInfo from "@components/new-ui/IndustriesSection/StatsInfo";
import IntegrationSection from "@components/new-ui/IntegrationSection";
import NewLayout from "@components/new-ui/Layout";
import { processEnv } from "@lib/processEnv";
import { CasestudyCard, CasestudyCardProps } from "@pages/case-study";
import { windowOpenNewTab } from "@utils/common";
import axios from "axios";
import { GetStaticProps } from "next";
import Image from "next/image";
import React from "react";
import { MdOutlineArrowForwardIos } from "react-icons/md";
import { IIndustries } from "../finance/whatsapp";

const featureInfo1: FeatureInfo = {
    mainTitle: "Capture and qualify student info",
    subtitle: "In a few clicks-just as they would like it",
    imageUrl: "https://assets.gallabox.com/gb-home/industry-logos/education/bot-with-ai.png",
    featureInfoList: [
        "Verified student enquiries from Meta ads and web widget",
        "Automated qualification of student credentials",
        "Real-time query resolution in under 30 seconds",
        "24/7 automated assistance",
    ],
};

const featureInfo2: FeatureInfo = {
    mainTitle: "Optimize admission processes",
    subtitle: "By making your screening process a breeze",
    imageUrl: "https://assets.gallabox.com/gb-home/industry-logos/education/custom-settings.png",
    featureInfoList: ["Streamlined application workflows", "Automated document collection", "Status tracking and updates", "Reduced administrative burden"],
};

const featureInfo3: FeatureInfo = {
    mainTitle: "Uncomplicate student onboarding",
    subtitle: "With timely updates and instant replies",
    imageUrl: "https://assets.gallabox.com/gb-home/industry-logos/education/onboarding.png",
    featureInfoList: ["Course information dissemination", "Sharing scholarship and financial aid details", "Campus facility overviews", "Program compatibility guidance"],
};

const featureInfo4: FeatureInfo = {
    mainTitle: "Nurture aspirants, engage students",
    subtitle: "By sustaining student interest with timely messages",
    imageUrl: "https://assets.gallabox.com/gb-home/industry-logos/education/automation-flow.png",
    featureInfoList: ["Personalized learning path suggestions", "Scholarships, accreditations, and offers", "Course and institute-related reminders", "Academic support channels"],
};

const featureInfo5: FeatureInfo = {
    mainTitle: "Be connected with parent and alumni groups",
    subtitle: "For nurturing a strong institutional ecosystem",
    imageUrl: "https://assets.gallabox.com/gb-home/industry-logos/education/course-feedback.png",
    featureInfoList: [
        "Sharing regular updates to keep parents informed",
        "Parent feedback collection for service improvement",
        "Encouraging alumni participation in events",
        "Leveraging alumni communities for job placements",
    ],
};

const caseStudyData: CasestudyCardProps[] = [
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/goireland.png",
        title: "GoIreland's Success Story : Improved Transparency and Increased Conversions",
        sector: "Education",
        externalLink: "/case-study/goireland",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/rostrum-card-image.png",
        title: "Gallabox transforms WhatsApp marketing for Rostrum Education",
        sector: "Education",
        externalLink: "/case-study/rostrum-education",
    },

    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/educenter.png",
        title: "How Educenter used WhatsApp to empower students and increased revenue by 40%",
        sector: "Education",
        externalLink: "/case-study/educenter",
    },
];

const clientLogosData: LogoObject[] = [
    { url: "https://assets.gallabox.com/gb-home/industry-logos/education/acres.svg", alt: "acres", width: 80, height: 60 },
    { url: "https://assets.gallabox.com/gb-home/industry-logos/education/aecc.svg", alt: "aecc", width: 134, height: 48 },
    { url: "https://assets.gallabox.com/gb-home/industry-logos/education/canadian-school.svg", alt: "canadian-school", width: 134, height: 48 },
    { url: "https://assets.gallabox.com/gb-home/industry-logos/education/cosmotology.svg", alt: "cosmotology", width: 100, height: 48 },
    { url: "https://assets.gallabox.com/gb-home/industry-logos/education/getmypolicy.svg", alt: "getmypolicy", width: 178, height: 40 },
    { url: "https://assets.gallabox.com/gb-home/industry-logos/education/global.svg", alt: "global", width: 109, height: 90 },
    { url: "https://assets.gallabox.com/gb-home/industry-logos/education/goireland.svg", alt: "goireland", width: 172, height: 38 },
    { url: "https://assets.gallabox.com/gb-home/industry-logos/education/iit.svg", alt: "iit", width: 110, height: 60 },
    { url: "https://assets.gallabox.com/gb-home/industry-logos/education/london-kids.svg", alt: "london-kids", width: 109, height: 90 },
    { url: "https://assets.gallabox.com/gb-home/industry-logos/education/nxtwave.svg", alt: "nxtwave", width: 160, height: 31 },
    { url: "https://assets.gallabox.com/gb-home/industry-logos/education/peakmind.svg", alt: "peakmind", width: 71, height: 76 },
    { url: "https://assets.gallabox.com/gb-home/industry-logos/education/xylem.svg", alt: "xylem", width: 180, height: 51 },
];

const EducationLanding: React.FC<IIndustries> = ({ categoryResult }) => {
    return (
        <NewLayout
            description="Discover AI-powered WhatsApp automation solutions for EdTech. Enhance student engagement, streamline communication, and boost efficiency with Gallabox."
            title="AI WhatsApp Automation Solutions for EdTech - Gallabox"
            canonical="https://gallabox.com/industry/education/whatsapp"
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/industry-logos/education/industrie-education-og.png" }}
            schema={{
                heroOrOgImageAlt: "education-industry-image",
                heroOrOgImageDescription:
                    "From the first student query to filling in the admissions form to making the course payment, do it all using Gallabox's WhatsApp automation features.",
                heroOrOgImageUrl: "https://assets.gallabox.com/gb-home/industry-logos/education/education-industries.png",
            }}
        >
            <Herosection />
            <StatsInfo />
            <section className={`${container_classname} my-10`}>
                <h3 className="text-center text-lg font-normal py-5">Trusted by 10,000+ businesses</h3>
                <ClientLogos logos={clientLogosData} />
            </section>
            <FeatureInfoCard {...featureInfo1} />
            <FeatureInfoCard {...featureInfo2} />
            <FeatureInfoCard {...featureInfo3} />
            <FeatureInfoCard {...featureInfo4} />
            <FeatureInfoCard {...featureInfo5} />
            <ProductSection />

            <section className={`${container_classname} py-20`}>
                <h2 className="md:text-6xl text-4xl mb-12" style={{ fontFamily: "Degular Display" }}>
                    Ready-to-test education chatbot templates
                </h2>
                <div className={"grid md:grid-cols-3 md:gap-5 gap-10"}>
                    {categoryResult.slice(0, 3).map((data: any) => (
                        <div
                            key={data.id}
                            className="border border-solid border-gray-200 rounded cursor-pointer"
                            onClick={() => windowOpenNewTab(`/whatsapp-chatbot-templates/${data.category}/${data.title}/${data.id}`)}
                        >
                            <div className="relative">
                                <img src={data.picture} alt={data.title} width={280} height={170} style={{ height: "200px" }} className="w-full" />

                                <div
                                    className="absolute top-0 left-0 w-full h-full"
                                    style={{
                                        background: "linear-gradient(180deg, rgba(51, 100, 250, 0.00) 0%, rgba(51, 100, 250, 0.12) 100%)",
                                    }}
                                ></div>
                            </div>
                            <div className="p-8 bg-white">
                                {data.tags?.map((tag: { name: string }) => (
                                    <p key={tag.name} className="mb-4 text-gray-700 text-sm">
                                        {tag.name.toUpperCase()}
                                    </p>
                                ))}
                                <p className="mb-12 text-2xl font-medium">{data.title}</p>
                                <div className="flex gap-x-4 items-center">
                                    <a
                                        href={`/try-template/${data.id}`}
                                        className="border border-solid border-blue-600 text-blue-600 rounded no-underline hover:no-underline text-sm"
                                        style={{ lineHeight: "14px", padding: "8px 12px 8px 12px" }}
                                    >
                                        TRY
                                    </a>
                                    <div className="flex gap-1 items-center">
                                        <Image src="/new-industries/education/view.svg" width={20} height={20} className="w-8 h-6" alt="visited" />
                                        {data.usedCount}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <p className="mt-9 text-blue-500 flex justify-center">
                    <a href="https://gallabox.com/whatsapp-chatbot-templates/education" className="flex items-center gap-x-2">
                        View all <MdOutlineArrowForwardIos size={14} />
                    </a>
                </p>
            </section>

            <section className="bg-gray-50 py-20">
                <div className={`${container_classname} `}>
                    <h4 className="md:text-6xl text-4xl pl-8 md:mb-12 mb-8" style={{ fontFamily: "Degular Display" }}>
                        Customer stories
                    </h4>
                    <div className={`${container_classname} grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-y-10 md:gap-y-0`}>
                        {caseStudyData.map((data, index) => (
                            <CasestudyCard key={index} {...data} />
                        ))}
                    </div>
                </div>
            </section>
            <IntegrationSection isLight={true} />
            <AwardsSection />
            <CTASection title="Grab student attention on their favorite channel. Just text them already." description="Take Gallabox for a 7-day ride" />
        </NewLayout>
    );
};

export default EducationLanding;

export const getStaticProps: GetStaticProps = async () => {
    let categoryResult;

    try {
        await axios({
            method: "get",
            url: "https://server.gallabox.com/devapi/bot-templates",
            headers: {
                apiSecret: process.env.REACT_APP_API_SECRET,
                apiKey: process.env.REACT_APP_API_KEY,
            },
            data: {
                status: "published",
                category: "education",
            },
        })
            .then(function (response) {
                categoryResult = JSON.parse(JSON.stringify(response?.data)) || [];
            })
            .catch(function (err) {
                console.log(err);
            });
    } catch (error) {
        throw new Error("Index creation failed.");
    }

    return {
        props: { categoryResult },
        ...(processEnv.isr.enable && { revalidate: 1 }),
    };
};
